import { render, staticRenderFns } from "./permissionManage.vue?vue&type=template&id=2a00ca09"
import script from "./permissionManage.vue?vue&type=script&lang=js"
export * from "./permissionManage.vue?vue&type=script&lang=js"
import style0 from "./permissionManage.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports